<script setup>
import CorrectionsStatsComponent from "@/Components/Corrections/CorrectionsStatsComponent.vue";
import CorrectionsListComponent from "@/Components/Corrections/CorrectionsListComponent.vue";
import {Permissions} from "@/Utils/Permissions";
import { DatePicker } from 'v-calendar';
import 'v-calendar/style.css';
import {reactive} from "vue";

const today = new Date();

const data = reactive({
  range: {
    start: new Date(new Date().setDate(today.getDate() - 30)),
    end: today
  }
});

const formatDate = (dateInput) => {
  if(dateInput !== null && dateInput !== undefined){
    return dateInput.toISOString().slice(0,10)
  }
  else{
    return new Date().toISOString().slice(0,10)
  }
}

</script>

<template>
  <v-container fluid style="height: auto">
    <v-row>
      <v-col cols="3">
        <v-card>
          <v-card-item>
            <v-card-title>
              Select Date Range
            </v-card-title>
            <v-card-subtitle>
              Closed Claims Returned for Corrections
            </v-card-subtitle>
          </v-card-item>
          <v-card-item>
            <DatePicker
                v-model.range="data.range"
                mode="date"
            >
            </DatePicker>
          </v-card-item>
        </v-card>
      </v-col>
      <v-col cols="9" v-if="Permissions.checkPermissions(['corrections.read'])">
        <CorrectionsStatsComponent :start="formatDate(data.range.start)" :end="formatDate(data.range.end)"/>
      </v-col>
      <v-col cols="12" v-if="Permissions.checkPermissions(['corrections.list'])">
        <CorrectionsListComponent :start="formatDate(data.range.start)" :end="formatDate(data.range.end)"/>
      </v-col>

    </v-row>
  </v-container>
</template>